/** Sibling IIFE: <dwtf-rank app-id="…" theme="dark"> — Shadow DOM, no Auth core. */
const API = "https://api.d.wtf";

class DwtfRankEl extends HTMLElement {
  connectedCallback() {
    const appId = this.getAttribute("app-id") || this.getAttribute("app") || "";
    const theme = this.getAttribute("theme") || "dark";
    const api = (this.getAttribute("api") || API).replace(/\/$/, "");
    const dark = theme !== "light";
    const shadow = this.attachShadow({ mode: "open" });
    const css = `.b{display:inline-flex;align-items:center;gap:8px;padding:6px 12px;border-radius:6px;font:12px/1.2 system-ui,sans-serif;text-decoration:none;background:${dark ? "#18181b" : "#f4f4f5"};color:${dark ? "#fff" : "#09090b"};border:1px solid ${dark ? "#27272a" : "#e4e4e7"}}
.n{font-weight:700;color:#38bdf8}`;
    if (!appId) {
      shadow.innerHTML = `<style>${css}</style><span class="b">d.wtf Rank</span>`;
      return;
    }
    fetch(`${api}/v1/rank/summary/${appId}`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((d) => {
        const href = d.portal_url || `${api}/rank/${d.slug || appId}`;
        shadow.innerHTML = `<style>${css}</style><a class="b" href="${href}" target="_blank" rel="noopener"><span>d.wtf Rank</span><span class="n">#${d.global_rank}</span></a>`;
      })
      .catch(() => {
        shadow.innerHTML = `<style>${css}</style><span class="b">d.wtf Rank</span>`;
      });
  }
}

customElements.define("dwtf-rank", DwtfRankEl);
